<template>
  <div id="app">
    <div class="preview-section" :style="rgba_color">
        <preview :step="step" :custom_color="color" />
    </div>
    <div class="content-section" @keyup.enter="to_step(step+1)">
        <step-0 v-if="step === 0" @change_value="change_email" :email="email" :invalid="invalid" />
        <step-1 v-if="step === 1" @change_value="change_name" :name="name" :invalid="invalid" />
        <step-2 v-if="step === 2" @change_value="change_description" :description="description" :invalid="invalid" />
        <step-3 v-if="step === 3" :custom_color="color" @change_color="change_color" :invalid="invalid" />
        <step-4 v-if="step === 4" @change_value="change_currency" :currency="currency" :invalid="invalid" />
        <step-5 v-if="step === 5" @change_value="change_password" :password="password" :invalid="invalid" />
        <p class="form-error" v-if="generic_error">{{generic_error}}</p>
        <action-buttons :step="step" @step="to_step" />
    </div>
  </div>
</template>

<script>

import Axios from 'axios';
import ESPromise from 'es6-promise';
import Preview from './Preview.vue'
import Step0 from './Step0.vue'
import Step1 from './Step1.vue'
import Step2 from './Step2.vue'
import Step3 from './Step3.vue'
import Step4 from './Step4.vue'
import Step5 from './Step5.vue'
import Buttons from './Buttons.vue'

ESPromise.polyfill();

export default {
  name: 'app',

  computed: {
      rgba_color: function() {

          if(!this.color) {
              return {};
          }

          let r = parseInt(this.color.slice(1, 3), 16),
              g = parseInt(this.color.slice(3, 5), 16),
              b = parseInt(this.color.slice(5, 7), 16);

          return {background: "rgba(" + r + ", " + g + ", " + b + ", 0.5)"};
      }
  },

  methods: {
    to_step: function(step) {
        this.generic_error = '';
        this.invalid = this.validate(step)
        if(this.invalid.length === 0 && step <= 5) {
            this.step = step;
        } else {
            if(step < this.step) {
                this.step = step;
            }
        }
    },
    change_color: function(clr) {
        this.invalid = [];
        this.color = clr;
    },
    change_email: function(email) {
        this.invalid = [];
        this.email = email;
    },
    change_name: function(name) {
        this.invalid = [];
        this.name = name;
    },
    change_password: function(pwd) {
        this.invalid = [];
        this.password = pwd;
    },
    change_currency: function(currency) {
        this.invalid = [];
        this.currency = currency;
    },
    change_description: function(desc) {
        this.invalid = [];
        this.description = desc;
    },

    process_data: function() {
        let post_data = JSON.parse(JSON.stringify(this.$data));
        let url = '/' + (document.documentElement.lang || 'en') + '/onboarding/'

        if(post_data['currency'] === 'USD') {
            url = 'https://us.consulto.com' + url
        }

        delete(post_data['step']);
        delete(post_data['invalid']);
        delete(post_data['generic_error']);
        Axios.post(url, post_data, {withCredentials: true}).then((resp) => {
            if(resp.data.success) {
                window.location.href = resp.data.redirect || 'dashboard/'
            } else {
                this.generic_error = resp.data.error
            }
        }).catch(function(err) {
            console.log('Error!: ', err);
        });
    },

    validate: function(step) {
        let invalid = [];
        let emailtest = /\S+@\S+\.\S+/;
        if(!emailtest.test(this.email)) {
            invalid.push('email');
        }

        if(this.step == 0) return invalid

        if(this.name.length < 2) {
            invalid.push('name');
        }

        if(this.step == 1) return invalid

        if(this.description.length < 6) {
            invalid.push('description');
        }

        if(this.step == 2) return invalid

        if(!this.color) {
            invalid.push('color');
        }

        if(this.step == 3) return invalid

        if(!this.currency) {
            invalid.push('currency');
        }

        if(this.step == 4) return invalid

        if(this.password.length < 8) {
            invalid.push('password');
        }

        if(this.step == 5 && step > 4 && invalid.length === 0) {
            this.process_data();
        }

        return invalid;
    }
  },
  data () {
    return {
      step: 0,
      color: null,
      email: '',
      name: '',
      description: '',
      password: '',
      currency: '',
      invalid: [],
      generic_error: ''
    }
  },
  components: {
    'preview': Preview,
    'step-0': Step0,
    'step-1': Step1,
    'step-2': Step2,
    'step-3': Step3,
    'step-4': Step4,
    'step-5': Step5,
    'action-buttons': Buttons
  }
}
</script>

<style>

#app {
    min-height: 500px;
    font-family: "Montserrat",sans-serif;
}

.wizard h2 {
    font-family: "Montserrat",sans-serif;
    color: #35bacf;
    font-size: 38px;
    line-height: 38px;
    letter-spacing: -1px;
    margin: 0px 0px 20px 0px;
}

.wizard p {
    color: #353434;
    size: 16px;
    line-height: 24px;
    margin: 10px 0px 20px;
}

.wizard input {
    font-family: "Montserrat",sans-serif;
    padding: 16px 20px;
    border: solid 1px #dcdcdc;
    border-radius: 4px;
    background: white;
    color: #2f2f30;
    font-size: 16px;
    line-height: 20px;
    display: block;
    max-width: 460px;
    width: 100%;
    margin: 10px 0 20px 0;
    outline: none;
}

.wizard textarea {
    font-family: "Montserrat",sans-serif;
    padding: 22px 20px;
    border: solid 1px #dcdcdc;
    border-radius: 4px;
    background: white;
    color: #2f2f30;
    font-size: 16px;
    line-height: 16px;
    display: block;
    max-width: 460px;
    width: 100%;
    height: 80px;
    margin: 10px 0 20px 0;
    outline: none;
    resize: none;
}

.wizard button {
    font-family: "Montserrat",sans-serif;
    font-size: 20px;
    padding: 20px 50px;
    margin: 10px 0;
    line-height: 20px;
    text-align: center;
    color: white;
    background: #35bacf;
    clear: both;
    float: none;
    border-radius: 4px;
    border: none;
    font-weight: bold;
    outline: none;
}

.wizard button.alternate-button {
    padding-left: 0;
    background: transparent;
    color: #35bacf;
}

@-webkit-keyframes vibrate-1{0%{-webkit-transform:translate(0);transform:translate(0)}20%{-webkit-transform:translate(-2px,2px);transform:translate(-2px,2px)}40%{-webkit-transform:translate(-2px,-2px);transform:translate(-2px,-2px)}60%{-webkit-transform:translate(2px,2px);transform:translate(2px,2px)}80%{-webkit-transform:translate(2px,-2px);transform:translate(2px,-2px)}100%{-webkit-transform:translate(0);transform:translate(0)}}@keyframes vibrate-1{0%{-webkit-transform:translate(0);transform:translate(0)}20%{-webkit-transform:translate(-2px,2px);transform:translate(-2px,2px)}40%{-webkit-transform:translate(-2px,-2px);transform:translate(-2px,-2px)}60%{-webkit-transform:translate(2px,2px);transform:translate(2px,2px)}80%{-webkit-transform:translate(2px,-2px);transform:translate(2px,-2px)}100%{-webkit-transform:translate(0);transform:translate(0)}}

.wizard .error {
    -webkit-animation: vibrate-1 0.3s linear infinite both;
    -moz-animation: vibrate-1 0.3s linear infinite both;
    animation: vibrate-1 0.3s linear infinite both;
    border: solid 1px red;
}

.wizard button:hover {
    background: #288b9a;
}

.wizard button.alternate-button {
    background: transparent;
    color: #288b9a;
}

.wizard label {
    display: block;
    font-weight: normal;
}


.wizard .content-section {
    padding: 75px;
    padding-bottom: 100px;
    width: 50%;
}

.wizard .preview-section {
    background: #94719C;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 50%;
    padding: 100px 50px;
    transition: background .5s ease;
}

.wizard .form-error {
    color: red;
    font-size: 0.9em;
}

@media (max-width: 800px) {
    .wizard .preview-section {
        position: static;
        width: auto;
        padding: 30px;
    }

    .wizard p {
        size: 14px;
        line-height: 18px;
    }


    .wizard h2 {
        font-size: 30px;
        line-height: 30px;
    }

    .wizard input {
        width: 100%;
    }

    .wizard button {
        font-size: 16px;
        line-height: 16px;
        padding: 13px 30px;
    }

    .wizard .content-section {
        padding: 30px;
        padding-bottom: 100px;
        width: auto;
        min-height: 450px;
    }
}



</style>



// WEBPACK FOOTER //
// App.vue?2b2c9f03